import carsService from '../../service/carsResource';
import transportationsService from '../../service/transportationsResource';
import { format } from 'date-fns';

const initalState = {
  optionsForCarAutoComplete: [],
  loadingOptionsForCarAutoComplete: false,
  carTransportations: [],
  loadingCarTransportations: false,
};

export const createCarTab = (set, get) => ({
  ...initalState,
  fetchCarTransportations: async (data) => {
    set({ error: '' });
    const sortModel = get().sortModel;
    const { field, sort } =
      sortModel.length > 0 ? sortModel[0] : { field: 'id', sort: 'desc' };
    const { t0, t1, vehicleId, isMobile } = data;
    if (vehicleId === '') {
      set({ error: 'Lütfen bir araç plakası seçin' });
      return;
    }
    try {
      set({
        loadingCarTransportations: false,
      });
      const params = {
        sort: `${field},${sort}`,
        t0: format(new Date(t0), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        t1: format(new Date(t1), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
      };
      const result =
        await transportationsService.findAllTransportationsByVehicleIdAndEndDateBetween(
          params,
          vehicleId,
        );
      if (result?.data?.data.length === 0) {
        set({ error: 'Herhangi bir veri bulunamadı' });
        return;
      }
      const fetchedData = result?.data?.data;
      set({ carTransportations: fetchedData });
    } catch (error) {
      set({ error: 'Bir hata ile karşılaşıldı.' });
      console.error('oops... error:', error);
    } finally {
      set({
        loadingCarTransportations: false,
      });
    }
  },
  fetchOptionsForCarAutoComplete: async (param) => {
    set({ error: '' });
    try {
      set({ loadingOptionsForCarAutoComplete: true });
      const result =
        await carsService.getDeviceVehicleRelationsSearchAll(param);
      const data = result?.data?.data;
      if (data.length === 0) {
        set({ error: 'Herhangi bir veri bulunamadı' });
        return;
      }
      const prepareToOptions = data.map((i) => i?.vehicle?.id);
      set({ optionsForCarAutoComplete: prepareToOptions });
    } catch (error) {
      set({ error: 'Bir hata ile karşılaşıldı.' });
      console.error('oops... error:', error);
    } finally {
      set({ loadingOptionsForCarAutoComplete: false });
    }
  },
  resetCarTransportations: () => {
    set({
      error: '',
      carTransportations: [],
      loadingCarTransportations: false,
    });
  },
});
